class Table {
  constructor(elementClass) {
    this.head = document.querySelectorAll(`.${elementClass}_head__icon`);
  }

  init() {
    for (const [index, element] of this.head.entries()) {
      if (index === 0) {
        element.parentElement.classList.toggle('js-active');
      }

      element.addEventListener('click', (event) => {
        this.handlClick(event);
      });
    }
  }

  handlClick(event) {
    const element = event.target.parentElement.classList;
    if (element.contains('js-active')) {
      element.remove('js-active');
    } else {
      for (const item of this.head) {
        item.parentElement.classList.remove('js-active');
      }
      element.add('js-active');
    }
  }
}

const table = new Table('table');
table.init()
